export enum GreybeeRoles {
    JUNIOR_PROJECT_MANAGER = 'JUNIOR_PROJECT_MANAGER',
    PROJECT_MANAGER = 'PROJECT_MANAGER',
    SENIOR_PROJECT_MANAGER = 'SENIOR_PROJECT_MANAGER',
    SOFTWARE_DEVELOPER = 'SOFTWARE_DEVELOPER'
}
